export const ScreenResolutions = {
  High: '2560x1440',
  Medium: '1920x1080',
  Low: '220x140'
}

type ScreenResolutions = typeof ScreenResolutions[keyof typeof ScreenResolutions];
